import {DomainSequenceType} from 'antibodies/domain-annotation/DomainAnnotationTypes';
import promptAndAnnotateDomainSequences from 'antibodies/domain-annotation/promptAndAnnotateDomainSequences';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import {ListableItem} from 'search/SearchConstants';
import * as ShortcutUtil from 'util/ShortcutUtil';

/**
 * Prompts for annotation settings and starts annotating the selected listing items. The items must already
 * pass `getDomainAnnotationDisabledReason`.
 *
 * @param actionOrigin The listing toolbar's action origin, recorded on the annotation's analytics events.
 */
export default async function annotateListingDomainSequences({
  items,
  sequenceType,
  actionOrigin,
}: {
  items: Array<ListableItem>;
  sequenceType: DomainSequenceType;
  actionOrigin: ActionOrigin;
}): Promise<void> {
  await promptAndAnnotateDomainSequences({
    sequenceIds: items.map((item) => item.id),
    sequenceType,
    initialFolderId: ShortcutUtil.findCommonProjectFolderId(items, []),
    actionOrigin,
  });
}
